import React from "react";
import "./Catalogue.css";
export default function Catalogue() {
  return (
    <>
      <div className="catalogue-copy">
        <h1>full catalogue</h1>
        <p>Scroll down and click to see our full inventory</p>
        <p>of generators, heaters & EV Chargers.</p>
        <p>Auxiliary products and attachments not shown.</p>
      </div>
      <img alt="" className="panel-img truck" src={"./imgs/trailer.png"} />
      <div className="catalogue-page-portion-summary">
        <div className="catalogue-item">
          <h2 className="cat-title">generators</h2>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">himoinsa hyw 45</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/himo.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">himoinsa hyw 60</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/HYW60-100.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">himoinsa hyw 100</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/HYW60-100.png"}
            />
          </a>
        </div>
      </div>
      <div className="catalogue-page-portion-summary">
        <div className="catalogue-item">
          <h2 className="cat-title">arcotherm heaters</h2>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">arcotherm jumbo 235</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/acrotherm.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">arcotherm jumbo 145</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/j145.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">arcotherm jumbo 85</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/acrotherm.png"}
            />
          </a>
        </div>
      </div>
      <div className="catalogue-page-portion-summary">
        <div className="catalogue-item">
          <h2 className="cat-title">thermobile heaters</h2>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">thermobile ita 75 (robust)</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/ita-75-robust.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">thermobile ita 45 (robust)</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/ita-45-robust.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">thermobile ita 75</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/ita-75.png"}
            />
          </a>
        </div>
      </div>

      <div className="catalogue-page-portion-summary">
        <div className="catalogue-item"></div>

        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">thermobile ita 45</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/ita-45.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">thermobile ita 30/35</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/ita3035.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">Accessories</h3>

            <img
              alt=""
              className="panel-img catalogue-img ac"
              src={"./imgs/Accessories.png"}
            />
          </a>
        </div>
      </div>
      <div className="catalogue-page-portion-summary">
        <div className="catalogue-item">
          <h2 className="cat-title">idev ev charger</h2>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">idev onsite ev charger</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/IDEVOnsiteEVCharger.png"}
            />
          </a>
        </div>
        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">idev onsite + ev charger</h3>
            <img
              alt=""
              className="panel-img catalogue-img"
              src={"./imgs/generator.png"}
            />
          </a>
        </div>

        <div className="catalogue-item">
          <a className="box-content">
            <h3 className="catalogue-header">Contact Us</h3>
            <img
              alt=""
              className="panel-img phone-img"
              src={"./imgs/phone.png"}
            />
            <p>
              <a href="https://www.brightpowersolutions.co.uk/contact">
                Click to contact us
              </a>
            </p>
          </a>
        </div>
      </div>
    </>
  );
}
